var render, staticRenderFns
import script from "./TheSearch.vue?vue&type=script&lang=js&"
export * from "./TheSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheSearch.vue"
export default component.exports